import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-cost-kpi-card',
  templateUrl: './cost-kpi-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostKpiCardComponent {
  readonly label = input.required<string>();
  readonly value = input.required<string>();
  readonly unit = input<string | null>(null);
  readonly icon = input<string | null>(null);
  readonly tone = input<'default' | 'pending' | 'positive' | 'negative'>('default');

  readonly toneColor = computed(() => {
    switch (this.tone()) {
      case 'positive':
        return 'var(--p-green-500)';
      case 'negative':
        return 'var(--p-red-500)';
      case 'pending':
        return 'var(--p-text-muted-color)';
      default:
        return 'var(--p-text-color)';
    }
  });

  readonly toneArrow = computed<string | null>(() => {
    switch (this.tone()) {
      case 'negative':
        return 'pi pi-arrow-up';
      case 'positive':
        return 'pi pi-arrow-down';
      default:
        return null;
    }
  });
}
